import { Subject, Subscription } from 'rxjs';

export enum EventsList {
  UPLOADSTARTED_EVENT = 'UploadStarted',
  CONNECTIONRESTORED_EVENT = 'ConnectionRestored',
  CONNECTIONDOWN_EVENT = 'ConnectonDown',
  UPLOAD_CLICKED = 'UploadClicked',
  UPLOAD_COMPLETED = 'UploadCompleted',
  UPLOAD_FOLDER_CLICKED = "UploadFolderClicked",
  UPLOAD_STARTED = 'UploadStarted',
  MYFILES_TABBED_VIEW = 'myFilesTabbedView',
  FAVORITES_TABBED_VIEW = 'favoritesTabbedView',
  SHARED_FILES_TABBED_VIEW = 'sharedFilesTabbedView',
  TAB_CLICKED = "TabClicked",
  POP_UP_TAB_CLICKED = "PopUpTabClicked",
  TABBED_VIEW_READY = "tabbedViewReadyToRender",
  POPUP_TABBED_VIEW_READY = "popUpTabbedViewReadyToRender",
  SHARED_PUBLIC_TABBED_VIEW = "publicLink",
  CHANGE_SORT_TYPE_OF_SHARED_FILES = "changeSharedFilesSort",
  COPY_TABBED_VIEW = "CopyPopUpTabbedView",
  DECIDE_TO_ENABLE_BUTTON = "decideIfButtonShouldBeEnabled",
  REFRESHVIEW = 'refreshInAppWebView',
  ALBUM_DETAILS_TABBED_VIEW = 'albumDetailsTabbedView',
  CONTACT_SEARCH_CLICKED = "ContactSearchClicked",
  CONTACT_SORTING = "ContactSortingClicked",
  UPDATE_DATA = "UPDATE_DATA",
  UPDATE_SP_RECENT_DATA = "updateSpRecentData",
  UPDATE_CONTEXT_MENU_ITEMS = "UpdateContextMenuItems",
  ENABLE_2FA = "Enable2FA",
  INTERNET_OFF = "INTERNET_OFF",
  INTERNET_ON = "INTERNET_ON",
  CHANGE_VIEW = "change_view",
  DYNAMIC_TOP_MENU_HEIGHT = "Dynamic_Height_For_Top_Menu",
  UPDATE_RECENT = 'UploadRecent',
  EMPTY_TABBED_VIEW = "empty_tabs",
  CLICKED_BACK_FROM_ADD_MEMBER = "clicked_back_from_add_member",
  UNIVERSAL_SHARE_TABBED_VEW = "UNIVERSAL_SHARE_TABBED_VEW",
  START_ENT_TOUR_FROM_INFO_BTN = "START_ENT_TOUR_FROM_INFO_BTN",
  STOP_ENT_TOUR_lEFT_MENU = "STOP_ENT_TOUR_lEFT_MENU",
  TOUR_STATUS = "TOUR_STATUS",
  ENT_MEMBER_TEAMS_FOLDER_TABBED_VIEW = "ENT_MEMBER_TEAMS_FOLDER_TABBED_VIEW",
  ENT_ADMIN_TEAMS_FOLDER_TABBED_VIEW = "ENT_ADMIN_TEAMS_FOLDER_TABBED_VIEW",
  ENT_VIEWER_TEAMS_FOLDER_TABBED_VIEW = "ENT_VIEWER_TEAMS_FOLDER_TABBED_VIEW",
  SHOW_EMAIL_VERIFIACTION_MODAL_FOR_PROFILE = "SHOW_EMAIL_VERIFIACTION_MODAL_FOR_PROFILE",
  SHOW_EMAIL_VERIFIACTION_MODAL_FOR_BACKUP_NO_PROFILE = "SHOW_EMAIL_VERIFIACTION_MODAL_FOR_BACKUP_NO_PROFILE",
  SHOW_EMAIL_VERIFICATION_MODAL_POST_ONBOARDING ="SHOW_EMAIL_VERIFICATION_MODAL_POST_ONBOARDING",
  HIGHLIGHT_ACTIVE_TAB = "HIGHLIGHT_ACTIVE_TAB",
  ALBUM_LIST_TABBED_VIEW = 'albumListTabbedView',
  ADD_TO_ALBUM_MODAL_TABBED_VIEW = "ADD_TO_ALBUM_MODAL_TABBED_VIEW",
  RECENT_UPLOAD_UPDATE = 'RecentlyUploaded',
  RECENTLY_ACCESSED_OBJ_FETCHED = "RecentlyAccessedObjFetched",
  SHOW_PEOPLES_SUGGESTIONS_AVAILABLE_MODAL = "SHOW_PEOPLES_SUGGESTIONS_AVAILABLE_MODAL",
  SHOW_PEOPLES_SUGGESTIONS_CONFIRMATION_MODAL ="SHOW_PEOPLES_SUGGESTIONS_CONFIRMATION_MODAL",
  SHOW_PEOPLES_SUGGESTIONS_THANKYOU_MODAL = "SHOW_PEOPLES_SUGGESTIONS_THANKYOU_MODAL",
  FACE_GROUPING_TOGGLE = "FACE_GROUPING_TOGGLE",
  SHOW_PEOPLES_FACES_DATA_POST_SUGGESTIONS = "SHOW_PEOPLES_FACES_DATA_POST_SUGGESTIONS",
  VIRTUAL_DOM_READY = "VIRTUAL_DOM_READY_TO_LISTEN_EVENTS",
  SHOW_ICLOUD_INITIAL_MODAL = "SHOW_ICLOUD_INITIAL_MODAL",
  SHOW_ICLOUD_2FA_MODAL = "SHOW_ICLOUD_2FA_MODAL",
  SHOW_TRANSFER_STATUS_MODAL ="SHOW_TRANSFER_STATUS_MODAL",
  RESEND_APPLE_2FA_TOKEN = "RESEND_APPLE_2FA_TOKEN",
  FACE_GROUPING_GET_LATEST_FACES_SEARCH = "FACE_GROUPING_GET_LATEST_FACES_SEARCH",
  EXPAND_SIDEBAR_MORE_MENU = "EXPAND_SIDEBAR_MORE_MENU",
  CLEAR_PEOPLE_DATA_IN_MEMORY = "CLEAR_PEOPLE_DATA_IN_MEMORY",
  VIDEO_PLAYER_RETRY = "VIDEO_PLAYER_RETRY",
  VIDEO_PLAYER_PAUSE = "VIDEO_PLAYER_PAUSE",
  DOWNTIME_BANNER = "DOWNTIME_BANNER",
  FETCH_DIGILOCKER_DOCS = "FETCH_DIGILOCKER_DOCS",
  FETCH_DIGILOCKER_ACCOUNT_FOLDERS = "FETCH_DIGILOCKER_ACCOUNT_FOLDERS",
  SHOW_SEARCH_FEEDBACK_POPUP = "SHOW_SEARCH_FEEDBACK_POPUP",
  SHOW_SEARCH_STATUS_POPUP = "SHOW_SEARCH_STATUS_POPUP"
}



class AppEventsEmitters {
  
  listeners = {};
  uploadCompleteEvent: Subject<object> = new Subject();
  uploadEventSubscription: Subscription;
  peopleTabEvent: Subject<object> = new Subject();
  placeTabEvent: Subject<object> = new Subject();
  peopleTabSubscription: Subscription;
  placeTabSubscription: Subscription;
  bannerEvent:  Subject<object> = new Subject();
  multiSelectEvent:  Subject<object> = new Subject();
  videoClapperEvent:  Subject<object> = new Subject();
  previewErrorEvent:  Subject<object> = new Subject();
  optionSelected: Subject<object> = new Subject();
  albumDetails: Subject<object> = new Subject();
  folderSpecificDragEvent:Subject<object> = new Subject();
  toastMessageEvent : Subject<object> = new Subject();
  updateLeftMenuStorage: Subject<object> = new Subject();
  updateUserStorage:Subject<object> = new Subject();
  startENTUpload:  Subject<object> = new Subject();
  internetEvents: Subject<object> = new Subject();
  contextMenuOperations: Subject<object> = new Subject();
  teamFolderSubscription: Subject<Object> = new Subject();
  updateProfileDetails: Subject<Object> = new Subject();
  objectPreview: Subject<Object> = new Subject();
  privateFolderOperations: Subject<Object> = new Subject();
  updateAuthData : Subject<Object> = new Subject();
  memorySubscriptions : Subject<Object> = new Subject();
  // fileOperationsEvents : Subject<Object> = new Subject();
  // fullScreenBannerClose : Subject<Object> = new Subject();
  globalObservable : Subject<Object> = new Subject();
  virtualDOMObservable : Subject<Object> = new Subject();
  cloudBridgeObsevable : Subject<Object> = new Subject();
  updateHeaderUI: Subject<Object> = new Subject();
  loginSubscriptions : Subject<Object> = new Subject();

  constructor() { }

  public unSubscribeOptionSelection(){
    this.optionSelected.observers = [];
    return;
  }


  createNewGlobalObservable(){
    this.globalObservable = new Subject();
  }

  public createNewSubscriptionsForTeamFolder(){
    this.teamFolderSubscription = new Subject();
  }

  public createNewFileOperationsSubscriptions(){
    this.optionSelected = new Subject();
  }

  public createNewPrivateFolderSubscription(){
    this.privateFolderOperations = new Subject();
  }

  public createNewSubscriptionsForLogin(){
    this.loginSubscriptions = new Subject();
  }

  public createNewMemorySubscription(){
    this.memorySubscriptions = new Subject();
  }

  public createNewBannerSubscriptions(){
    this.bannerEvent = new Subject();
  }

  public createNewfolderSpecificDragSubscriptions(){
    this.folderSpecificDragEvent = new Subject();
  }

  public createNewSubscriptionsForcontextMenuOperations(){
    this.contextMenuOperations = new Subject();
  }


  private addListener(eventName, fn) {
    this.listeners[eventName] = this.listeners[eventName] || [];
    if (this.listeners[eventName].length == 0) {
      this.listeners[eventName].push(fn)
    }
    return;
  }

  public on(eventName, fn) {

    this.addListener(eventName, fn);
  }

  public off(eventName, fn) {
    return this.removeListener(eventName, fn);
  }

  public removeAllEventListener(eventName) {
    let lis = this.listeners[eventName];
    if (!lis) return this;
    for (let i = lis.length; i > 0; i--) {
      this.listeners[eventName] = []
    }
    return;
  }

  private removeListener(eventName, fn) {
    let lis = this.listeners[eventName];
    if (!lis) return this;
    for (let i = lis.length; i > 0; i--) {
      if (lis[i] === fn) {
        lis.splice(i, 1);
        break;
      }
    }
    return this;
  }

  public emit(eventName, ...args) {
    let classRef = this;
    let fns = this.listeners[eventName];
    if (!fns) return false;
    fns.forEach((f) => {
      f(...args);
    });
    return;
  }

  public eventlistenerCount(eventName) {
    let fns = this.listeners[eventName] || [];
    return fns.length;
  }

  public getRegisteredEvents() {
    return Object.keys(this.listeners).reduce((arr, evt) => {
      if (this.eventlistenerCount(evt)) {
        arr.push(evt);
      }
      return arr;
    }, []);
  }
}

export var AppEvents = new AppEventsEmitters();